import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IllustrationTruckEnvelope = function IllustrationTruckEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 140 140"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    stroke: "#FFA6B6",
    d: "m59.832 62.39 23.032 13.97.19.114.042.218 6.49 33.664.009.045v.047l.105 17.843 41.8-24.07V92.849c0-1.707-.322-4.52-1.3-7.892l-.001-.003-9.021-31.904-.016-.057-.003-.056v-.002l-.001-.015-.007-.071a3 3 0 0 0-.046-.292 5 5 0 0 0-.329-1.02c-.339-.761-.979-1.698-2.194-2.442l-1.396.838-.284.17-.268-.195-15.142-11.032z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    stroke: "#00204D",
    d: "m73.465 113.477-.048.048-.107.038-3.311 1.168.77 3.079.014.06v.062c0 .551.001 1.063.103 1.678l.002.01.001.01c.101.807.408 1.631.722 2.259l.027.054.013.059.867 3.853 3.87-1.354.081-.029h.022l.004-.002.005-.002c.025-.012.073-.037.126-.057a.8.8 0 0 1 .258-.049h.005c1.766-.806 2.985-3.246 2.474-6.119-.313-1.612-1.064-2.97-2.023-3.865-.917-.857-2.004-1.277-3.091-1.144a1 1 0 0 1-.112.071c-.144.072-.293.067-.328.066h-.01c-.1.04-.193.066-.254.083l-.03.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE5374",
    stroke: "#DE5374",
    d: "m61.114 61.484-.007-.005-.008-.005-1.757-1.146v50.717l6.763 3.978q.087-.163.204-.356c.302-.491.774-1.12 1.444-1.63a4.35 4.35 0 0 1 2.651-.915c1.093-.006 2.35.375 3.785 1.322l.02.013.02.016-.315.388.315-.388.002.001.003.003.011.009.04.034.14.123c.119.108.287.266.488.473.403.413.94 1.022 1.488 1.812 1.061 1.529 2.17 3.751 2.394 6.546l9.905 5.803-.104-17.777-6.482-33.508-.003-.013-.002-.013v-.004l-.004-.021-.016-.092a8.133 8.133 0 0 0-.481-1.558c-.403-.949-1.091-2.06-2.24-2.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    stroke: "#00204D",
    d: "m27.59 87.515-.048.047-.107.038-3.311 1.169.77 3.079.014.06v.061c0 .551.001 1.064.104 1.678l.001.01.001.01c.101.807.408 1.632.721 2.26l.028.054.013.059.867 3.853 3.87-1.355.081-.028h.022l.004-.002.005-.002c.024-.013.073-.037.126-.057a.7.7 0 0 1 .258-.049h.005c1.765-.806 2.985-3.247 2.474-6.12-.313-1.612-1.064-2.969-2.023-3.865-.917-.857-2.004-1.276-3.091-1.144a.7.7 0 0 1-.112.071.7.7 0 0 1-.328.067h-.01c-.1.04-.193.065-.254.082z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    stroke: "#34519F",
    d: "M23.942 88.842c-2.251.392-3.855 3.164-3.286 6.43.57 3.266 3.016 5.332 5.267 4.94s3.855-3.164 3.286-6.43c-.57-3.267-3.017-5.333-5.267-4.94Z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "illustration-truck-envelope_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m78.314 122.772 10.891 6.381z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "m78.314 122.772 10.891 6.381z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "m78.82 121.91 10.89 6.38-1.01 1.726-10.891-6.381zm9.88 8.106-10.891-6.381 1.01-1.725 10.892 6.38z",
    mask: "url(#illustration-truck-envelope_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    stroke: "#FFA6B6",
    d: "m32.925 96.398 25.417 14.191V88.753L26.055 72.068l-15.708 7.907-.47 3.48 10.252 6.05c.47-.855 1.054-1.455 1.692-1.86a4.74 4.74 0 0 1 2.267-.713 6.4 6.4 0 0 1 2.536.369l.03.011c3.116.835 4.686 3.225 5.47 5.335a13.7 13.7 0 0 1 .801 3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FBFE",
    stroke: "#F9FBFE",
    d: "m94.487 105.497 29.011-16.958-6.885-25.846-28.376 16.322zm-13.323-.602L76.87 80.288l-11.258-6.795v22.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    stroke: "#34519F",
    d: "M119.549 99.774c-.766 2.781.412 5.301 2.326 5.828s4.217-1.033 4.983-3.814c.767-2.781-.412-5.3-2.326-5.828-1.913-.528-4.216 1.033-4.983 3.814ZM69.87 114.796c-2.25.392-3.854 3.165-3.285 6.431.57 3.266 3.016 5.332 5.267 4.94 2.25-.393 3.855-3.165 3.286-6.431-.57-3.266-3.017-5.332-5.267-4.94Zm26.228-1.498c-.767 2.781.412 5.301 2.325 5.828s4.217-1.033 4.983-3.814c.767-2.781-.412-5.3-2.325-5.828-1.914-.527-4.217 1.033-4.984 3.814ZM49.827 55.213l.003-.001 27.145-12.668L19.98 12.197l23.791 45.89z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "illustration-truck-envelope_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.041 55.665-6.49 3.08z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "m50.041 55.665-6.49 3.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "m50.47 56.569-6.49 3.08-.858-1.807 6.49-3.08zm-7.348 1.273 6.49-3.08.858 1.806-6.49 3.08z",
    mask: "url(#illustration-truck-envelope_svg__b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "illustration-truck-envelope_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.041 55.665 28.053-13.092L43.55 58.745z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "m50.041 55.665 28.053-13.092L43.55 58.745z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "m50.041 55.665-.429-.904.006-.003zm28.053-13.092-.423-.906.847 1.812zM43.55 58.745l.424.906-.852-1.81zm6.068-3.986 28.053-13.092.846 1.812-28.053 13.092zm28.9-11.28L43.974 59.65l-.848-1.812 34.544-16.17zM43.122 57.842l6.49-3.08.858 1.806-6.49 3.08z",
    mask: "url(#illustration-truck-envelope_svg__c)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "illustration-truck-envelope_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.55 80.528 15.292 7.92z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "m43.55 80.528 15.292 7.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "m44.01 79.64 15.292 7.92-.92 1.777-15.292-7.921zm14.372 9.697L43.09 81.416l.92-1.776 15.292 7.92z",
    mask: "url(#illustration-truck-envelope_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    stroke: "#34519F",
    d: "m43.762 59.198-.434.204-.222-.427-23.808-45.924v54.302l24.482 12.73.001.001 14.561 7.542V59.111l.258-.143L77.594 48.44v-5.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    stroke: "#00204D",
    d: "m43.107 58.975-15.761-30.4 15.115 33.21L65.184 49.17 43.762 59.198l-.434.204z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE5374",
    stroke: "#DE5374",
    d: "M58.342 91.47v-2.717L26.058 72.069l-2.328 1.202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    stroke: "#34519F",
    d: "m122.912 87.77.099.37-.333.191-28.39 16.317.2.849 29.01-16.958-6.889-25.86-.307.167zm-50.14 12.542 8.4 4.587-.01-.065z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD7DF",
    stroke: "#FFD7DF",
    d: "m59.838 59.422 19.797 11.94 38.016-22.874-17.25-11.709z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    stroke: "#FFA6B6",
    d: "m8.954 82.927.282-2.087c-.167.15-.326.32-.455.5-.232.324-.324.627-.262.91.04.183.156.414.435.677Zm79.75 22.717a59.102 59.102 0 0 1 .916 7.359l.718-1.627-.828-4.968z"
  }));
};